import { BLOCK_TIME_MS } from './bsc';

export const DEFAULT_REFETCH_INTERVAL_MS = BLOCK_TIME_MS * 3; // every 3 blocks (9 seconds)
